import React from "react";
import { shouldShowFreebetTag } from "@utils/offer/shouldShowFreebetTag";

export default function FreebetTag(props: {
    isFreebet?: boolean;
    transactionTypeAbrv?: string;
    amount?: number;
    className?: string;
    isInlineTag?: boolean;
}) {
    if (!shouldShowFreebetTag(props)) {
        return null;
    }

    if (props.isInlineTag) {
        return <strong> - Freebet</strong>;
    }

    return (
        <div className={`widget--bets__tag tag tag--bet tag--slip--paid-out ${props.className ?? "tag--tny"}`}>
            Freebet
        </div>
    );
}